// globals.ts

import SecureLS from 'secure-ls';

import { VUEX_KEY } from '@/enums'; // the key used by localStorage

export const secureStorage = new SecureLS({ isCompression: false });

const initialStoreContent = secureStorage.get(VUEX_KEY);
export const initialUnencryptedStorage = initialStoreContent
  ? JSON.parse(initialStoreContent)
  : {}; // parse the localStorage value to an object when it's defined, else set it as an empty object

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
